const menuItems = [
  { label: "HOME", link: "/" },
  { label: "ABOUT", link: "/about" },

  {
    label: "ELEVATORS",
    dropdown: [
      {
        label: "Residential",
        submenu: [
          { label: "Indivisual Villas", link: "/elevators/residential/villas" },
          { label: "Residential Appartment", link: "/elevators/residential/apartment" },
        ],
      },
      {
        label: "Commercial",
        submenu: [
          { label: "Hospital", link: "/elevators/commercial/hospital" },
          { label: "Office Lifts", link: "/elevators/commercial/office" },
          { label: "Hotel Lifts", link: "/elevators/commercial/hotel" },
          { label: "IT Park Lifts", link: "/elevators/commercial/itpark" },
          { label: "Malls & Retails Stores Lifts", link: "/elevators/commercial/malls" },
          { label: "Factory | Industory Lift", link: "/elevators/commercial/factory" },
        ],
      },
    ],
  },

  { label: "ESCALATORS", link: "/escalators" },

  {
    label: "PRODUCTS",
    dropdown: [
      { label: "Cabin Design", link: "/products/cabin" },
      { label: "Door", link: "/products/door" },
      { label: "Machine", link: "/products/machine" },
      { label: "Control Panel", link: "/products/control-panel" },
      { label: "Operating Panel", link: "/products/operating-panel" },
      { label: "Drawing", link: "/products/drawing" },
    ],
  },

  { label: "SERVICES", link: "/services" },
  { label: "MEDIA", link: "/media" },

  {
    label: "PRESTIGIOUS CLIENTS",
    dropdown: [
      { label: "Government Projects", link: "/clients/government" },
      { label: "Private", link: "/clients/private" },
    ],
  },

  { label: "CAREER", link: "/career" },
  { label: "CONTACT", link: "/contact" },
];

export default menuItems;
